import { render, staticRenderFns } from "./deduction.vue?vue&type=template&id=22cf83cf"
import script from "./deduction.vue?vue&type=script&lang=js"
export * from "./deduction.vue?vue&type=script&lang=js"
import style0 from "./deduction.vue?vue&type=style&index=0&id=22cf83cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports